import * as gateway from 'sfx-web-contract';
import { AlkLogger } from '@alk/core';
import { COMMUNICATION_SERVICE, ICommunicationService } from '../communication';
import { decodeAmendOrderResponse, encodeAmendOrderRequest } from './amend-order-adapter.service.utils';
import { filter, finalize, map, take, takeUntil, tap } from 'rxjs/operators';
import { IAmendOrderAdapterService } from './amend-order-adapter.interface';
import { IAmendOrderRequest, IAmendOrderResponse } from '../../interfaces';
import { inject, injectable } from 'inversify';
import { ISessionLifecycle, SESSION_LIFECYCLE_SERVICE } from '../session-lifecycle';

@injectable()
export class AmendOrderAdapterService implements IAmendOrderAdapterService {

    @inject(COMMUNICATION_SERVICE) private readonly communicationService: ICommunicationService;
    @inject(SESSION_LIFECYCLE_SERVICE) private readonly sessionLifeCycle: ISessionLifecycle;

    amendOrder(request: IAmendOrderRequest): Promise<IAmendOrderResponse> {

        AlkLogger.info(`[AmendOrderAdapterService#amendOrder] is about to amend order with ${ JSON.stringify(request) } `);

        const requestId = this.communicationService
            .create(
                encodeAmendOrderRequest(request),
                gateway.MessageTypes.AmendPendingOrder,
            );

        return this.communicationService.dataObservable(gateway.MessageTypes.AmendPendingOrder).pipe(
            filter(response => response.communicationToken === requestId),
            takeUntil(this.sessionLifeCycle.destroyObservable()),
            finalize(() => this.communicationService.delete(requestId)),
            tap((response) =>
                AlkLogger.info(`[AmendOrderAdapterService#amendOrder] response with requestId ${ requestId } ${ ''
                } for amend order ${ JSON.stringify(request) } is ${ JSON.stringify(response) }`)),
            take(1),
            map(decodeAmendOrderResponse),
        ).toPromise();

    }
}
